import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsCategoryPage from "../pages/category/news/page";
import WorksCategoryPage from "../pages/category/works/page";
import CultureCategoryPage from "../pages/category/culture/page";
import NewsDetailPage from "../pages/detail/news/page";
import WorkDetailPage from "../pages/detail/works/page";
import CultureDetailPage from "../pages/detail/culture/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/news",
    element: <NewsCategoryPage />,
  },
  {
    path: "/category/works",
    element: <WorksCategoryPage />,
  },
  {
    path: "/category/culture",
    element: <CultureCategoryPage />,
  },
  {
    path: "/detail/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/detail/works/:id",
    element: <WorkDetailPage />,
  },
  {
    path: "/detail/culture/:id",
    element: <CultureDetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;